import { createSelector } from 'reselect';
import { getLang } from 'utils';
import { getDisplayedName, getPrice, getProductId, getProductImagesCount } from 'features/product-info';
import { getBreadcrumbs } from 'features/page-model';
import { computeFaqVariables } from '../utils/compute-faq-variables';

export const getFaqVariables = createSelector(
  getProductImagesCount,
  getBreadcrumbs,
  getProductId,
  getPrice,
  getLang,
  getDisplayedName,
  (imagesCount, breadcrumbs, productId, price, lang, displayedName) =>
    computeFaqVariables({
      imagesCount,
      breadcrumbs,
      productId,
      price,
      lang,
      displayedName,
    }),
);
